<!-- 一般ユーザー　予約情報確認画面-->
<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_price.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_reservation.css" type="text/css" media="all" scoped></style>
<style scoped>

</style>
<template>
  <div class="container" id="step05">
    <div class="contents">
      <h2>健診予約</h2>
		  <section class="flow">
		  	<h3>予約申し込みの流れ</h3>
		  	<ol>
		  	  <li>コース選択</li>
		  	  <li>オプション選択</li>
		  	  <li>受診日時選択</li>
		  	  <li>予約情報入力</li>
		  	  <li>予約情報確認</li>
		  	  <li>予約確定</li>
		  	</ol>
		  </section>
      <!-- ▽  -->
      <section id="mainContents">
        <section class="inputArea">
          <h3>【予約情報確認】</h3>
          <p>下記内容をご確認の上、問題がなければ「確定する」ボタンをクリックしてください。</p>
          <p>内容を修正する場合は「戻る」ボタンをクリックしてください。</p>
          <!-- 予約情報 -->
          <section class="reservation">
            <ul class="date"><li>{{getYearOfReserveDate}}<!--年--></li><li>{{getMonthOfReserveDate}}<!--月--></li><li>{{getDateOfReserveDate}}<!--日--></li><li>{{confirm.reserveSthm}}<!--時間--></li></ul>
				    <dl class="plan">
					    <dt>{{confirm.course.ksnm}}</dt>
					    <dd class="option">
                <b>追加オプション</b>
                <ul>
                  <li v-for="item in confirm.optionList" v-bind:key="item.ksnm">
                    {{item.opnm}}
                  </li>
                </ul>
              </dd>
					  </dl>
					  <div class="price">
					  	<p class="total">
                合計金額
                <b>
                  <template v-if="confirm.kshj=='1'">
                    {{getSumKngk | moneyDelimiter}}
                    <span v-if="confirm.taxk=='1'">（税抜）</span>
                    <span v-else>（税込）</span>
                  </template>
                </b>
              </p>
					  </div>
          </section>
          <!-- 個人情報 -->
          <section class="personalDataTbl">
				    <dl v-if="confirm.jgcdIsDisplay">
              <dt>健康保険組合名</dt>
				    	<dd>{{confirm.jgnm}}</dd>
				    </dl>
				    <dl v-if="confirm.hkshIsDisplay">
              <dt>保険者番号</dt>
				    	<dd>{{confirm.hksh}}</dd>
				    </dl>
            <dl v-if="confirm.hkkgIsDisplay">
              <dt>保険証記号</dt>
              <dd>{{confirm.hkkg}}</dd>
            </dl>
            <dl v-if="confirm.hknoIsDisplay">
              <dt>保険証番号</dt>
              <dd>{{confirm.hkno}}</dd>
            </dl>
				    <dl v-if="confirm.hfkbIsDisplay">
              <dt>対象者区分</dt>
				    	<dd>{{this.confirm.kbnm}}</dd>
				    </dl>
				    <dl v-if="confirm.cmnmIsDisplay">
              <dt>企業名</dt>
				    	<dd>{{this.confirm.cmnm}}</dd>
				    </dl>
            <dl class="nameOutput" v-if="(confirm.ryk1IsDisplay&&confirm.ryk2IsDisplay) || (confirm.nam1IsDisplay&&confirm.nam2IsDisplay)">
              <dt>氏名</dt>
              <dd class="separate">
								<!-- 氏名（カタカナ） -->
                <ul v-if="confirm.ryk1IsDisplay&&confirm.ryk2IsDisplay">
                  <li>{{this.confirm.ryk1}}</li><li>{{this.confirm.ryk2}}</li>
                </ul>
								<!-- 氏名（漢字） -->
                <ul v-if="confirm.nam1IsDisplay&&confirm.nam2IsDisplay">
                  <li>{{this.confirm.nam1}}</li><li>{{this.confirm.nam2}}</li>
                </ul>
              </dd>
            </dl>
				    <dl class="birthday" v-if="confirm.btdyYearIsDisplay&&confirm.btdyMonthIsDisplay&&confirm.btdyDateIsDisplay">
              <dt>生年月日</dt>
				    	<dd><ul><li>{{this.confirm.btdyYear}}</li><li>{{this.confirm.btdyMonth}}</li><li>{{this.confirm.btdyDate}}</li></ul></dd>
				    </dl>
				    <dl class="age" v-if="confirm.ageIsDisplay">
              <dt>年齢</dt>
				    	<dd><span>受診日時点での年度年齢</span><b>{{this.confirm.age}}</b></dd>
				    </dl>
				    <dl v-if="confirm.sexIsDisplay">
              <dt>性別</dt>
				    	<dd>
                {{computedStrSex}}
              </dd>
				    </dl>
				    <dl class="add" v-if="confirm.zip1IsDisplay&&confirm.zip2IsDisplay&&confirm.adr1IsDisplay&&confirm.adr2IsDisplay">
              <dt>ご住所</dt>
				    	<dd>
				    		<ul>
				    			<li class="zip">{{computedStrZip}}</li>
				    			<li>{{computedStrAddr}}</li>
				    		</ul>
				    	</dd>
				    </dl>
				    <dl v-if="confirm.tel1IsDisplay">
              <dt>電話番号</dt>
				    	<dd>
				    		<ul>
				    			<li class="tel">{{this.confirm.tel1}}</li>
				    		</ul>
				    	</dd>
				    </dl>
            <dl v-if="confirm.synoIsDisplay">
              <dt>社員番号</dt>
              <dd>{{this.confirm.syno}}</dd>
            </dl>
				    <dl v-if="confirm.emailIsDisplay">
              <dt>メールアドレス</dt>
				    	<dd>{{this.confirm.email}}</dd>
				    </dl>
            <dl v-if="confirm.dmkbIsDisplay">
              <dt>ＤＭ・メルマガ</dt>
              <dd>{{computedStrDmkb}}</dd>
            </dl>
				    <dl v-if="confirm.mem1IsDisplay">
              <dt>備考</dt>
				    	<dd>{{this.confirm.mem1}}</dd>
				    </dl>
          </section>
          <div class="btnLst">
            <button class="backBtn" v-on:click="onBack">戻る</button>
            <button class="confBtn" v-on:click="onReserveConfirmModalOpen">確定する</button>
          </div>
        </section>
      </section>
      <!-- △ mainContents END -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.reserveStart.isShow" v-on:close="onReserveStartModalClose">
        <dt slot="modal-header">予約処理中</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.reserveStart.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.reserveConfirm.isShow" v-on:close="onReserveConfirmModalClose">
        <dt slot="modal-header">予約確認</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.reserveConfirm.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer">
          <button class="cancelBtn" v-on:click="onConfirm">送信</button>
          <button class="backBtn" v-on:click="onReserveConfirmModalClose">閉じる</button>
        </dd>
      </modalWindow>
      <!-- モーダルWindow E -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
        <dt slot="modal-header">入力エラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
        <dt slot="modal-header">システムエラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
    </div>
  </div>
</template>
<script>
  import { Auth } from '@/api/'
  import { CommonConfirmReserveInfo } from '@/api'
  import * as types from '@/store/mutation-types'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'CommonConfirmReserveInfo',
    // 使用コンポーネント
    components: {
      // エラー表示コンポーネント
      errorMessageBox: ErrorMessageBox,
      // モーダルウィンドウ表示コンポーネント
      modalWindow: ModalWindow
    },
    // 算出プロパティ
    computed: {
      // 選択した日付から年を表示
      getYearOfReserveDate: function() {
          var result = ''
          var tempDate = null

          if('' == this.confirm.reserveDate) {
              return result
          }
          // 選択した日付
          tempDate = new Date(this.confirm.reserveDate)
          result = tempDate.getFullYear()

          return result
      },
      // 選択した日付から月を表示
      getMonthOfReserveDate: function() {
          var result = ''
          var tempDate = null

          if('' == this.confirm.reserveDate) {
              return result
          }
          // 選択した日付
          tempDate = new Date(this.confirm.reserveDate)
          result = String(parseInt(tempDate.getMonth()) + 1)

          return result
      },
      // 選択した日付から日を表示
      getDateOfReserveDate: function() {
        var result = ''
        var tempDate = null

        if('' == this.confirm.reserveDate) {
            return result
        }

        // 選択した日付
        tempDate = new Date(this.confirm.reserveDate)
        result = tempDate.getDate()

        return result
      },
      // 選択したコース及びオプション項目の合計金額
      // （消費税考慮済み金額）
      getSumKngk: function() {

        // 合計金額
        var resultSumKngk = 0

        // 選択したコースの金額
        resultSumKngk += this.confirm.course.gkgk

        // 選択したオプションの金額を加える
        this.confirm.optionList.forEach(
          item => { resultSumKngk += item.gkgk }
        )

        return resultSumKngk
      },
      // 性別 表示用文字列を取得
      computedStrSex: function() {

        var result = ''
        
        if(this.confirm.codeSexMan == this.confirm.sex) {
          result = '男性'
        } else if(this.confirm.codeSexWoman == this.confirm.sex) {
          result = '女性'
        }

        return result
      },
      // 郵便番号 表示用文字列を取得
      computedStrZip: function() {
        
        var result = ''

        if('' == this.confirm.zip1 || '' == this.confirm.zip1 ){
          return result
        }

        result = this.confirm.zip1 + '-' + this.confirm.zip2

        return result
      },
      // 住所 表示用文字列を取得
      computedStrAddr: function() {
        
        var result = ''

        if('' == this.confirm.adr1 || '' == this.confirm.adr2 ){
          return result
        }

        result = this.confirm.adr1 + this.confirm.adr2
        
        if('' != this.confirm.adr3 && this.confirm.adr3IsDisplay){
          result += this.confirm.adr3
        }

        return result
      },
      // ＤＭ・メルマガ 表示用文字列を取得
      computedStrDmkb: function() {
        
        var result = ''

        if(this.confirm.codeDmkbNG == this.confirm.dmkb) {
          result = '受け取らない'
        } else if(this.confirm.codeDmkbOK == this.confirm.dmkb) {
          result = '受け取る'
        }

        return result
      }
    },
    // データ
    data() {
      return {
        // ユーザータイプ
        userType: '0',
        // 0: マイページ経由かつ新規予約（個人）
        codeUserTypeMyPageNewIndividual: '0',
        // 1: マイページ経由かつ新規予約（健保）
        codeUserTypeMyPageNewHealth: '1',
        // 2: マイページ経由かつ予約変更（個人）
        codeUserTypeMyPageChangeIndividual: '2',
        // 3: マイページ経由かつ予約変更（健保）
        codeUserTypeMyPageChangeHealth: '3',
        // 4: ゲストログインかつ新規予約（個人）
        codeUserTypeGuestNewIndividual: '4',
        // 5: ゲストログインかつ新規予約（健保）
        codeUserTypeGuestNewHealth: '5',
        // 6: 途中ログインかつ新規予約（個人）
        codeUserTypeEnRouteNewIndividual: '6',
        // 7: 途中ログインかつ新規予約（健保）
        codeUserTypeEnRouteNewHealth: '7',

        // 確認項目
        confirm: {
          // 予約日付
          reserveDate: '',
          // 予約時間帯　開始時間表示名
          reserveSthm: '',

          // 消費税区分
          // 1: 外税 税抜
          // 2: 内税 税込
          taxk: '',

          // 金額表示
          // 0:非表示 1:表示
          kshj: '',

          // 選択したコース
          // ksnm コース名称
          // gkgk 消費税考慮済み金額
          // （消費税区分と金額表示に依存）
          course: {
            ksnm: '',
            gkgk: 0,
          },

          // 選択したオプション
          // opnm オプション項目名称
          // gkgk 消費税考慮済み金額
          // （消費税区分と金額表示に依存）
          optionList: [],

          // 健康保険組合名（クライアント名）
          jgnm: '',
          // 保険者番号
          hksh: '',
          // 保険証記号
          hkkg: '',
          // 保険証番号
          hkno: '',
          // 対象者区分名
          kbnm: '',
          // 企業名
          cmnm: '',
          // 漢字氏名
          nam1: '',
          nam2: '',
          // カナ氏名
          ryk1: '',
          ryk2: '',
          // 生年月日　年
          btdyYear: 0,
          // 生年月日　月
          btdyMonth: 0,
          // 生年月日　日付
          btdyDate: 0,
          // 年齢
          age: 0,
          // 性別の選択値 1:男、2:女
          sex: '',
          // 性別 男のコード値
          codeSexMan: '1',
          // 性別 女のコード値
          codeSexWoman: '2',
          // ご住所
          // 郵便番号
          zip1: '',
          zip2: '',
          // 都道府県
          adr1: '',
          // 住所１（市区町村）
          adr2: '',
          // 住所２（番地）
          adr3: '',
          // 電話番号（日中連絡先）
          tel1: '',
          // 社員番号
          syno: '',
          // メールアドレス
          email: '',
          // ＤＭ・メルマガ 0:受け取らない、1:受け取る
          dmkb: '',
          // ＤＭ・メルマガ 受け取らないのコード値
          codeDmkbNG: '0',
          // ＤＭ・メルマガ 受け取るのコード値
          codeDmkbOK: '1',
          // 備考
          mem1: '',

          // 健康保険組合名
          // 表示非表示フラグ
          jgcdIsDisplay: false,
          // 保険者番号
          hkshIsDisplay: false,
          // 保険証記号
          hkkgIsDisplay: false,
          // 保険証番号
          hknoIsDisplay: false,
          // 対象者区分
          hfkbIsDisplay: false,
          // 企業名
          cmnmIsDisplay: false,
          // 漢字氏名
          // 姓
          nam1IsDisplay: false,
          // 名
          nam2IsDisplay: false,
          // カナ氏名
          // 姓
          ryk1IsDisplay: false,
          // 名
          ryk2IsDisplay: false,
          // 生年月日
          // 年
          btdyYearIsDisplay: false,
          // 月
          btdyMonthIsDisplay: false,
          // 日
          btdyDateIsDisplay: false,
          // 年齢
          ageIsDisplay: false,
          // 性別
          sexIsDisplay: false,
          // ご住所
          // 郵便番号 前半
          zip1IsDisplay: false,
          // 郵便番号 後半
          zip2IsDisplay: false,
          // 都道府県
          adr1IsDisplay: false,
          // 住所１（市区町村）
          adr2IsDisplay: false,
          // 住所２（番地）
          adr3IsDisplay: false,
					// 電話番号
          tel1IsDisplay: false,
          // 社員番号
          synoIsDisplay: false,
          // メールアドレス
          emailIsDisplay: false,
          // ＤＭ・メルマガ
          dmkbIsDisplay: false,
          // 備考
          mem1IsDisplay: false,
				},
        // モーダルウィンドウ
        modal: {
					// 予約処理中
					reserveStart: {
            messages: [
              '予約処理中'
            ],
            isShow: false
					},
					// 予約確認
					reserveConfirm: {
            messages: [
              'この内容で予約しますか？'
            ],
            isShow: false
					},
          // 入力エラー
          validationError: {
            messages: [],
            isShow: false
          },
          // システムエラー
          systemError: {
            messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
            isShow: false
          }
        }
      }
    },
    // フィルター
    filters: {
      // 金額表示用三桁ごとにカンマをつける
      moneyDelimiter: function(value) {

        if(value == null) {
          return ''
        }
        
        return value.toLocaleString()
      }
    },
		// ライフサイクルフック: created
    created: function () {
      UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::created Start')

      this.firstDisplay()

      UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::created End')
    },
    methods: {
      // 表示系--------------------------------------------------S
			// 初期表示
      firstDisplay: function () {
				UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::firstDisplay Start')

        // ストアに登録
        this.$store.commit(
         types.COMMON_CONFIRMRESERVE_FIRSTDISPLAY)

				// ストアからデータ取得
        this.confirm.reserveDate = this.$store.state.commonUserInfo.selectCalender.date

				this.confirm.hksh = this.$store.state.commonUserInfo.newHealthInsurance.hksh
				this.confirm.hkkg = this.$store.state.commonUserInfo.inputReserveInfo.hkkg
				this.confirm.hkno = this.$store.state.commonUserInfo.inputReserveInfo.hkno
				this.confirm.cmnm = this.$store.state.commonUserInfo.inputReserveInfo.cmnm
				this.confirm.nam1 = this.$store.state.commonUserInfo.inputReserveInfo.nam1
				this.confirm.nam2 = this.$store.state.commonUserInfo.inputReserveInfo.nam2
				this.confirm.ryk1 = this.$store.state.commonUserInfo.inputReserveInfo.ryk1
				this.confirm.ryk2 = this.$store.state.commonUserInfo.inputReserveInfo.ryk2
				this.confirm.btdyYear = this.$store.state.commonUserInfo.inputReserveInfo.btdyYear
				this.confirm.btdyMonth = this.$store.state.commonUserInfo.inputReserveInfo.btdyMonth
				this.confirm.btdyDate = this.$store.state.commonUserInfo.inputReserveInfo.btdyDate
        this.confirm.age = this.$store.state.commonUserInfo.inputReserveInfo.age
				this.confirm.sex = this.$store.state.commonUserInfo.inputReserveInfo.sex
				this.confirm.zip1 = this.$store.state.commonUserInfo.inputReserveInfo.zip1
				this.confirm.zip2 = this.$store.state.commonUserInfo.inputReserveInfo.zip2
				this.confirm.adr1 = this.$store.state.commonUserInfo.inputReserveInfo.adr1
				this.confirm.adr2 = this.$store.state.commonUserInfo.inputReserveInfo.adr2
				this.confirm.adr3 = this.$store.state.commonUserInfo.inputReserveInfo.adr3
				this.confirm.tel1 = this.$store.state.commonUserInfo.inputReserveInfo.tel1
				this.confirm.syno = this.$store.state.commonUserInfo.inputReserveInfo.syno
				this.confirm.email = this.$store.state.commonUserInfo.inputReserveInfo.email
				this.confirm.dmkb = this.$store.state.commonUserInfo.inputReserveInfo.dmkb
				this.confirm.mem1 = this.$store.state.commonUserInfo.inputReserveInfo.mem1

        // クライアントコード
        // 00000000は個人固定
        var tempJgcd = ''
        tempJgcd = this.$store.state.commonUserInfo.newHealthInsurance.jgcd

        // クライアント名（健康保険組合名）
        this.confirm.jgnm = this.$store.state.commonUserInfo.inputReserveInfo.jgnm

        // 初期値を取得する
        CommonConfirmReserveInfo.FirstDisplay({
          token: this.$store.state.auth.token,
          ircd: this.$store.state.auth.ircd,
          tmzn: this.$store.state.commonUserInfo.selectCalender.tmzn,
					jgcd: tempJgcd,
					hfkb: this.$store.state.commonUserInfo.inputReserveInfo.hfkb,
          nend: this.$store.state.commonUserInfo.newHealthInsurance.nend,
          sex: this.$store.state.commonUserInfo.inputReserveInfo.sex,
          kscd: this.$store.state.commonUserInfo.selectCourse.kscd,
          courseJkcd: this.$store.state.commonUserInfo.selectCourse.jkcd,
          opbrs: this.$store.state.commonUserInfo.selectOption.opbr,
          opcds: this.$store.state.commonUserInfo.selectOption.opcd,
          optionJkcds: this.$store.state.commonUserInfo.selectOption.jkcd
        }).then(({ responce }) => {
					
          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

					  // レスポンスからデータ取得
            this.confirm.reserveSthm = responce.data.sthm

            this.confirm.taxk = responce.data.taxk
            this.confirm.kshj = responce.data.kshj
            this.confirm.course.ksnm = responce.data.course.ksnm
            this.confirm.course.gkgk = responce.data.course.gkgk
            this.confirm.optionList = responce.data.optionList
					  this.confirm.kbnm = responce.data.kbnm

            // ユーザータイプを決める
            this.userType = this.getUserType(tempJgcd)

            // ユーザータイプによってそれぞれ初期設定
            // （表示非表示）を行う
            this.setInitializeValue()
            
          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
            this.onSystemErrorModalOpen()
          }

        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::firstDisplay End')
	      })
			},
      // ストア値などからユーザータイプを取得
      getUserType: function(in_jgcd){

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::getUserType Start')
      
      	var resultUserType = ''

      	// マイページ経由、ゲストログイン、途中ログインかどうか
      	if(this.$store.state.commonUserInfo.myPage.isUse) {
      	  // マイページ経由

      	  // 新規予約か予約変更どうか
      	  if(this.$store.state.commonUserInfo.myPage.choiceUkno == '') {
      	    // 新規予約

      	    // 個人か健保かどうか
      	    if(!this.$store.state.commonUserInfo.newHealthInsurance.isUse){
      	      // 個人
      	      resultUserType = this.codeUserTypeMyPageNewIndividual
      	    } else {
      	      // 健保
      	      resultUserType = this.codeUserTypeMyPageNewHealth
      	    }
      	  } else {
      	    // 予約変更

      	    // 個人か健保かどうか
      	    if('00000000' == in_jgcd) {
      	      // 個人
      	      resultUserType = this.codeUserTypeMyPageChangeIndividual
      	    } else {
      	      // 健保
      	      resultUserType = this.codeUserTypeMyPageChangeHealth
      	    }
      	  }
      	} else if(!this.$store.state.commonUserInfo.enRouteLogin.isUse) {
      	  // 途中ログイン
      	  // 個人か健保かどうか
      	  if(!this.$store.state.commonUserInfo.newHealthInsurance.isUse){
      	    // 個人
      	    resultUserType = this.codeUserTypeGuestNewIndividual
      	  } else {
      	    // 健保
      	    resultUserType = this.codeUserTypeGuestNewHealth
      	  }
      	} else {
      	  // ゲストログイン（マイページ経由、ゲストログイン、途中ログイン）
      	  // 個人か健保かどうか
      	  if(!this.$store.state.commonUserInfo.newHealthInsurance.isUse){
            // 個人
      	    resultUserType = this.codeUserTypeEnRouteNewIndividual
      	  } else {
      	    // 健保
      	    resultUserType = this.codeUserTypeEnRouteNewHealth
      	  }
      	}

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::getUserType End')

      	return resultUserType
      },
      // ユーザータイプによって初期化関数を呼び出す
      setInitializeValue: function() {
        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValue Start')

        if(this.codeUserTypeMyPageNewIndividual == this.userType) {
          // 0: マイページ経由かつ新規予約（個人）
          this.setInitializeValueMyPageNewIndividual()
        } else if(this.codeUserTypeMyPageNewHealth == this.userType) {
          // 1: マイページ経由かつ新規予約（健保）
          this.setInitializeValueMyPageNewHealth()
        } else if(this.codeUserTypeMyPageChangeIndividual == this.userType) {
          // 2: マイページ経由かつ予約変更（個人）
          this.setInitializeValueMyPageChangeIndividual()
        } else if(this.codeUserTypeMyPageChangeHealth == this.userType) {
          // 3: マイページ経由かつ予約変更（健保）
          this.setInitializeValueMyPageChangeHealth()
        } else if(this.codeUserTypeGuestNewIndividual == this.userType) {
          // 4: ゲストログインかつ新規予約（個人）
          this.setInitializeValueGuestNewIndividual()
        } else if(this.codeUserTypeGuestNewHealth == this.userType) {
          // 5: ゲストログインかつ新規予約（健保）
          this.setInitializeValueGuestNewHealth()
        } else if(this.codeUserTypeEnRouteNewIndividual == this.userType) {
          // 6: 途中ログインかつ新規予約（個人）
          this.setInitializeValueEnRouteNewIndividual()
        } else if(this.codeUserTypeEnRouteNewHealth == this.userType) {
          // 7: 途中ログインかつ新規予約（健保）
          this.setInitializeValueEnRouteNewHealth()
        }

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValue End')
      },
      // 0: マイページ経由かつ新規予約（個人）時の各項目初期化
      setInitializeValueMyPageNewIndividual: function() {
        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueMyPageNewIndividual Start')

        // 健康保険組合名
        this.confirm.jgcdIsDisplay = true

        // 保険者番号
        this.confirm.hkshIsDisplay = false

        // 保険証記号
        this.confirm.hkkgIsDisplay = true

        // 保険証番号
        this.confirm.hknoIsDisplay = true

        // 対象者区分
        this.confirm.hfkbIsDisplay = true

        // 企業名
        this.confirm.cmnmIsDisplay = true

        // 漢字氏名
        // 姓
        this.confirm.nam1IsDisplay = true
        // 名
        this.confirm.nam2IsDisplay = true

        // カナ氏名
        // 姓
        this.confirm.ryk1IsDisplay = true
        // 名
        this.confirm.ryk2IsDisplay = true

        // 生年月日
        // 年
        this.confirm.btdyYearIsDisplay = true
        // 月
        this.confirm.btdyMonthIsDisplay = true
        // 日
        this.confirm.btdyDateIsDisplay = true

        // 年齢
        this.confirm.ageIsDisplay = true

        // 性別
        this.confirm.sexIsDisplay = true

        // ご住所
        // 郵便番号 前半
        this.confirm.zip1IsDisplay = true
        // 郵便番号 後半
        this.confirm.zip2IsDisplay = true
        // 都道府県
        this.confirm.adr1IsDisplay = true
        // 住所１（市区町村）
        this.confirm.adr2IsDisplay = true
        // 住所２（番地）
        this.confirm.adr3IsDisplay = true

        // 電話番号
        this.confirm.tel1IsDisplay = true

        // 社員番号
        this.confirm.synoIsDisplay = true

        // メールアドレス
        this.confirm.emailIsDisplay = true

        // ＤＭ・メルマガ
        this.confirm.dmkbIsDisplay = true

        // 備考
        this.confirm.mem1IsDisplay = true

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueMyPageNewIndividual End')
      },
      // 1: マイページ経由かつ新規予約（健保）時の各項目初期化
      setInitializeValueMyPageNewHealth: function() {
        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueMyPageNewHealth Start')

        // 健康保険組合名
        this.confirm.jgcdIsDisplay = true

        // 保険者番号
        this.confirm.hkshIsDisplay = true

        // 保険証記号
        this.confirm.hkkgIsDisplay = true

        // 保険証番号
        this.confirm.hknoIsDisplay = true

        // 対象者区分
        this.confirm.hfkbIsDisplay = true

        // 企業名
        this.confirm.cmnmIsDisplay = true

        // 漢字氏名
        // 姓
        this.confirm.nam1IsDisplay = true
        // 名
        this.confirm.nam2IsDisplay = true

        // カナ氏名
        // 姓
        this.confirm.ryk1IsDisplay = true
        // 名
        this.confirm.ryk2IsDisplay = true

        // 生年月日
        // 年
        this.confirm.btdyYearIsDisplay = true
        // 月
        this.confirm.btdyMonthIsDisplay = true
        // 日
        this.confirm.btdyDateIsDisplay = true

        // 年齢
        this.confirm.ageIsDisplay = true

        // 性別
        this.confirm.sexIsDisplay = true

        // ご住所
        // 郵便番号 前半
        this.confirm.zip1IsDisplay = true
        // 郵便番号 後半
        this.confirm.zip2IsDisplay = true
        // 都道府県
        this.confirm.adr1IsDisplay = true
        // 住所１（市区町村）
        this.confirm.adr2IsDisplay = true
        // 住所２（番地）
        this.confirm.adr3IsDisplay = true

        // 電話番号
        this.confirm.tel1IsDisplay = true

        // 社員番号
        this.confirm.synoIsDisplay = true

        // メールアドレス
        this.confirm.emailIsDisplay = true

        // ＤＭ・メルマガ
        this.confirm.dmkbIsDisplay = false

        // 備考
        this.confirm.mem1IsDisplay = true

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueMyPageNewHealth End')
      },
      // 2: マイページ経由かつ予約変更（個人）時の各項目初期化
      setInitializeValueMyPageChangeIndividual: function() {
        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueMyPageChangeIndividual Start')

        // 健康保険組合名
        this.confirm.jgcdIsDisplay = true

        // 保険者番号
        this.confirm.hkshIsDisplay = false

        // 保険証記号
        this.confirm.hkkgIsDisplay = true

        // 保険証番号
        this.confirm.hknoIsDisplay = true

        // 対象者区分
        this.confirm.hfkbIsDisplay = true

        // 企業名
        this.confirm.cmnmIsDisplay = true

        // 漢字氏名
        // 姓
        this.confirm.nam1IsDisplay = true
        // 名
        this.confirm.nam2IsDisplay = true

        // カナ氏名
        // 姓
        this.confirm.ryk1IsDisplay = true
        // 名
        this.confirm.ryk2IsDisplay = true

        // 生年月日
        // 年
        this.confirm.btdyYearIsDisplay = true
        // 月
        this.confirm.btdyMonthIsDisplay = true
        // 日
        this.confirm.btdyDateIsDisplay = true

        // 年齢
        this.confirm.ageIsDisplay = true

        // 性別
        this.confirm.sexIsDisplay = true

        // ご住所
        // 郵便番号 前半
        this.confirm.zip1IsDisplay = true
        // 郵便番号 後半
        this.confirm.zip2IsDisplay = true
        // 都道府県
        this.confirm.adr1IsDisplay = true
        // 住所１（市区町村）
        this.confirm.adr2IsDisplay = true
        // 住所２（番地）
        this.confirm.adr3IsDisplay = true

        // 電話番号
        this.confirm.tel1IsDisplay = true

        // 社員番号
        this.confirm.synoIsDisplay = true

        // メールアドレス
        this.confirm.emailIsDisplay = true

        // ＤＭ・メルマガ
        this.confirm.dmkbIsDisplay = true

        // 備考
        this.confirm.mem1IsDisplay = true

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueMyPageChangeIndividual End')
      },
      // 3: マイページ経由かつ予約変更（健保）時の各項目初期化
      setInitializeValueMyPageChangeHealth: function() {
        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueMyPageChangeHealth Start')

        // 健康保険組合名
        this.confirm.jgcdIsDisplay = true

        // 保険者番号
        this.confirm.hkshIsDisplay = true

        // 保険証記号
        this.confirm.hkkgIsDisplay = true

        // 保険証番号
        this.confirm.hknoIsDisplay = true

        // 対象者区分
        this.confirm.hfkbIsDisplay = true

        // 企業名
        this.confirm.cmnmIsDisplay = true

        // 漢字氏名
        // 姓
        this.confirm.nam1IsDisplay = true
        // 名
        this.confirm.nam2IsDisplay = true

        // カナ氏名
        // 姓
        this.confirm.ryk1IsDisplay = true
        // 名
        this.confirm.ryk2IsDisplay = true

        // 生年月日
        // 年
        this.confirm.btdyYearIsDisplay = true
        // 月
        this.confirm.btdyMonthIsDisplay = true
        // 日
        this.confirm.btdyDateIsDisplay = true

        // 年齢
        this.confirm.ageIsDisplay = true

        // 性別
        this.confirm.sexIsDisplay = true

        // ご住所
        // 郵便番号 前半
        this.confirm.zip1IsDisplay = true
        // 郵便番号 後半
        this.confirm.zip2IsDisplay = true
        // 都道府県
        this.confirm.adr1IsDisplay = true
        // 住所１（市区町村）
        this.confirm.adr2IsDisplay = true
        // 住所２（番地）
        this.confirm.adr3IsDisplay = true

        // 電話番号
        this.confirm.tel1IsDisplay = true

        // 社員番号
        this.confirm.synoIsDisplay = true

        // メールアドレス
        this.confirm.emailIsDisplay = true

        // ＤＭ・メルマガ
        this.confirm.dmkbIsDisplay = false

        // 備考
        this.confirm.mem1IsDisplay = true

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueMyPageChangeHealth End')
      },
      // 4: ゲストログインかつ新規予約（個人）時の各項目初期化
      setInitializeValueGuestNewIndividual: function() {
        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueGuestNewIndividual Start')

        // 健康保険組合名
        this.confirm.jgcdIsDisplay = true

        // 保険者番号
        this.confirm.hkshIsDisplay = false

        // 保険証記号
        this.confirm.hkkgIsDisplay = true

        // 保険証番号
        this.confirm.hknoIsDisplay = true

        // 対象者区分
        this.confirm.hfkbIsDisplay = true

        // 企業名
        this.confirm.cmnmIsDisplay = true

        // 漢字氏名
        // 姓
        this.confirm.nam1IsDisplay = true
        // 名
        this.confirm.nam2IsDisplay = true

        // カナ氏名
        // 姓
        this.confirm.ryk1IsDisplay = true
        // 名
        this.confirm.ryk2IsDisplay = true

        // 生年月日
        // 年
        this.confirm.btdyYearIsDisplay = true
        // 月
        this.confirm.btdyMonthIsDisplay = true
        // 日
        this.confirm.btdyDateIsDisplay = true

        // 年齢
        this.confirm.ageIsDisplay = true

        // 性別
        this.confirm.sexIsDisplay = true

        // ご住所
        // 郵便番号 前半
        this.confirm.zip1IsDisplay = true
        // 郵便番号 後半
        this.confirm.zip2IsDisplay = true
        // 都道府県
        this.confirm.adr1IsDisplay = true
        // 住所１（市区町村）
        this.confirm.adr2IsDisplay = true
        // 住所２（番地）
        this.confirm.adr3IsDisplay = true

        // 電話番号
        this.confirm.tel1IsDisplay = true

        // 社員番号
        this.confirm.synoIsDisplay = true

        // メールアドレス
        this.confirm.emailIsDisplay = true

        // ＤＭ・メルマガ
        this.confirm.dmkbIsDisplay = true

        // 備考
        this.confirm.mem1IsDisplay = true

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueGuestNewIndividual End')
      },
      // 5: ゲストログインかつ新規予約（健保）時の各項目初期化
      setInitializeValueGuestNewHealth: function() {
        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueGuestNewHealth Start')

        // 健康保険組合名
        this.confirm.jgcdIsDisplay = true

        // 保険者番号
        this.confirm.hkshIsDisplay = true

        // 保険証記号
        this.confirm.hkkgIsDisplay = true

        // 保険証番号
        this.confirm.hknoIsDisplay = true
 
        // 対象者区分
        this.confirm.hfkbIsDisplay = true

        // 企業名
        this.confirm.cmnmIsDisplay = true

        // 漢字氏名
        // 姓
        this.confirm.nam1IsDisplay = true
        // 名
        this.confirm.nam2IsDisplay = true

        // カナ氏名
        // 姓
        this.confirm.ryk1IsDisplay = true
        // 名
        this.confirm.ryk2IsDisplay = true

        // 生年月日
        // 年
        this.confirm.btdyYearIsDisplay = true
        // 月
        this.confirm.btdyMonthIsDisplay = true
        // 日
        this.confirm.btdyDateIsDisplay = true

        // 年齢
        this.confirm.ageIsDisplay = true

        // 性別
        this.confirm.sexIsDisplay = true

        // ご住所
        // 郵便番号 前半
        this.confirm.zip1IsDisplay = true
        // 郵便番号 後半
        this.confirm.zip2IsDisplay = true
        // 都道府県
        this.confirm.adr1IsDisplay = true
        // 住所１（市区町村）
        this.confirm.adr2IsDisplay = true
        // 住所２（番地）
        this.confirm.adr3IsDisplay = true

        // 電話番号
        this.confirm.tel1IsDisplay = true

        // 社員番号
        this.confirm.synoIsDisplay = true

        // メールアドレス
        this.confirm.emailIsDisplay = true

        // ＤＭ・メルマガ
        this.confirm.dmkbIsDisplay = false

        // 備考
        this.confirm.mem1IsDisplay = true

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueGuestNewHealth End')
      },
      // 6: 途中ログインかつ新規予約（個人）時の各項目初期化
      setInitializeValueEnRouteNewIndividual: function() {
        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueEnRouteNewIndividual Start')

        // 健康保険組合名
        this.confirm.jgcdIsDisplay = true

        // 保険者番号
        this.confirm.hkshIsDisplay = false

        // 保険証記号
        this.confirm.hkkgIsDisplay = true

        // 保険証番号
        this.confirm.hknoIsDisplay = true

        // 対象者区分
        this.confirm.hfkbIsDisplay = true

        // 企業名
        this.confirm.cmnmIsDisplay = true

        // 漢字氏名
        // 姓
        this.confirm.nam1IsDisplay = true
        // 名
        this.confirm.nam2IsDisplay = true

        // カナ氏名
        // 姓
        this.confirm.ryk1IsDisplay = true
        // 名
        this.confirm.ryk2IsDisplay = true

        // 生年月日
        // 年
        this.confirm.btdyYearIsDisplay = true
        // 月
        this.confirm.btdyMonthIsDisplay = true
        // 日
        this.confirm.btdyDateIsDisplay = true

        // 年齢
        this.confirm.ageIsDisplay = true

        // 性別
        this.confirm.sexIsDisplay = true

        // ご住所
        // 郵便番号 前半
        this.confirm.zip1IsDisplay = true
        // 郵便番号 後半
        this.confirm.zip2IsDisplay = true
        // 都道府県
        this.confirm.adr1IsDisplay = true
        // 住所１（市区町村）
        this.confirm.adr2IsDisplay = true
        // 住所２（番地）
        this.confirm.adr3IsDisplay = true

        // 電話番号
        this.confirm.tel1IsDisplay = true

        // 社員番号
        this.confirm.synoIsDisplay = true

        // メールアドレス
        this.confirm.emailIsDisplay = true

        // ＤＭ・メルマガ
        this.confirm.dmkbIsDisplay = true

        // 備考
        this.confirm.mem1IsDisplay = true

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueEnRouteNewIndividual End')
      },
      // 7: 途中ログインかつ新規予約（健保）時の各項目初期化
      setInitializeValueEnRouteNewHealth: function() {
        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueEnRouteNewHealth Start')

        // 健康保険組合名
        this.confirm.jgcdIsDisplay = true

        // 保険者番号
        this.confirm.hkshIsDisplay = true

        // 保険証記号
        this.confirm.hkkgIsDisplay = true

        // 保険証番号
        this.confirm.hknoIsDisplay = true

        // 対象者区分
        this.confirm.hfkbIsDisplay = true

        // 企業名
        this.confirm.cmnmIsDisplay = true

        // 漢字氏名
        // 姓
        this.confirm.nam1IsDisplay = true
        // 名
        this.confirm.nam2IsDisplay = true

        // カナ氏名
        // 姓
        this.confirm.ryk1IsDisplay = true
        // 名
        this.confirm.ryk2IsDisplay = true

        // 生年月日
        // 年
        this.confirm.btdyYearIsDisplay = true
        // 月
        this.confirm.btdyMonthIsDisplay = true
        // 日
        this.confirm.btdyDateIsDisplay = true

        // 年齢
        this.confirm.ageIsDisplay = true

        // 性別
        this.confirm.sexIsDisplay = true

        // ご住所
        // 郵便番号 前半
        this.confirm.zip1IsDisplay = true
        // 郵便番号 後半
        this.confirm.zip2IsDisplay = true
        // 都道府県
        this.confirm.adr1IsDisplay = true
        // 住所１（市区町村）
        this.confirm.adr2IsDisplay = true
        // 住所２（番地）
        this.confirm.adr3IsDisplay = true

        // 電話番号
        this.confirm.tel1IsDisplay = true

        // 社員番号
        this.confirm.synoIsDisplay = true

        // メールアドレス
        this.confirm.emailIsDisplay = true

        // ＤＭ・メルマガ
        this.confirm.dmkbIsDisplay = false

        // 備考
        this.confirm.mem1IsDisplay = true

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::setInitializeValueEnRouteNewHealth End')
      },
      // 表示系--------------------------------------------------E
      // 確定する
      onConfirm: function() {
        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onConfirm Start')

        // 予約確認モーダルを閉じる
        this.onReserveConfirmModalClose()
        // 予約処理中モーダルを開く
        this.onReserveStartModalOpen()

        // ログイン状況に応じてWebApiを呼び出す
        if(this.userType == this.codeUserTypeGuestNewIndividual
          || this.userType == this.codeUserTypeGuestNewHealth) {

          // ゲストログイン新規予約時
          // 4: ゲストログインかつ新規予約（個人）codeUserTypeGuestNewIndividual
          // 5: ゲストログインかつ新規予約（健保）codeUserTypeGuestNewHealth
          CommonConfirmReserveInfo.GuestNewReserve({
            ircd: this.$store.state.auth.ircd,
            jgcd: this.$store.state.commonUserInfo.newHealthInsurance.jgcd,
            jgnm: this.confirm.jgnm,
            hksh: this.confirm.hksh,
            newHealthInsuranceSex: this.$store.state.commonUserInfo.newHealthInsurance.sex,
            newHealthInsuranceNend: this.$store.state.commonUserInfo.newHealthInsurance.nend,
            newHealthInsuranceAge: this.$store.state.commonUserInfo.newHealthInsurance.age,
            newHealthInsuranceHfkb: this.$store.state.commonUserInfo.newHealthInsurance.hfkb,
            inputReserveSex: this.$store.state.commonUserInfo.inputReserveInfo.sex,
            inputReserveBtdyYear: this.$store.state.commonUserInfo.inputReserveInfo.btdyYear,
            inputReserveBtdyMonth: this.$store.state.commonUserInfo.inputReserveInfo.btdyMonth,
            inputReserveBtdyDate: this.$store.state.commonUserInfo.inputReserveInfo.btdyDate,
            inputReserveAge: this.$store.state.commonUserInfo.inputReserveInfo.age,
            inputReserveHfkb: this.$store.state.commonUserInfo.inputReserveInfo.hfkb,
            kscd: this.$store.state.commonUserInfo.selectCourse.kscd,
            courseJkcd: this.$store.state.commonUserInfo.selectCourse.jkcd,
            opbr: this.$store.state.commonUserInfo.selectOption.opbr,
            opcd: this.$store.state.commonUserInfo.selectOption.opcd,
            optionJkcd: this.$store.state.commonUserInfo.selectOption.jkcd,
            reserveDate: this.$store.state.commonUserInfo.selectCalender.date,
            reserveTmzn: this.$store.state.commonUserInfo.selectCalender.tmzn,
            jgnm: this.$store.state.commonUserInfo.inputReserveInfo.jgnm,
            hkkg: this.$store.state.commonUserInfo.inputReserveInfo.hkkg,
            hkno: this.$store.state.commonUserInfo.inputReserveInfo.hkno,
            cmnm: this.$store.state.commonUserInfo.inputReserveInfo.cmnm,
            nam1: this.$store.state.commonUserInfo.inputReserveInfo.nam1,
            nam2: this.$store.state.commonUserInfo.inputReserveInfo.nam2,
            ryk1: this.$store.state.commonUserInfo.inputReserveInfo.ryk1,
            ryk2: this.$store.state.commonUserInfo.inputReserveInfo.ryk2,
            zip1: this.$store.state.commonUserInfo.inputReserveInfo.zip1,
            zip2: this.$store.state.commonUserInfo.inputReserveInfo.zip2,
            adr1: this.$store.state.commonUserInfo.inputReserveInfo.adr1,
            adr2: this.$store.state.commonUserInfo.inputReserveInfo.adr2,
            adr3: this.$store.state.commonUserInfo.inputReserveInfo.adr3,
            tel1: this.$store.state.commonUserInfo.inputReserveInfo.tel1,
            syno: this.$store.state.commonUserInfo.inputReserveInfo.syno,
            email: this.$store.state.commonUserInfo.inputReserveInfo.email,
            dmkb: this.$store.state.commonUserInfo.inputReserveInfo.dmkb,
            mem1: this.$store.state.commonUserInfo.inputReserveInfo.mem1
          }).then(({ reserveResponce }) => {
            
            if (reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

              // ログインしてなければログイン処理を行う
              if(!this.$store.getters.isCommonUserLogin) {
                // レスポンスからデータ取得
                // ユーザーID
                var tempUserId = reserveResponce.data.userId
                // 初期パスワード
                var tempFirstPassword = reserveResponce.data.firstPassword
                // システムID
                var tempTrsq = ''
                // 受診者名
                var tempName = ''
                // 予約受付番号
                var tempUkno = reserveResponce.data.ukno

                // ログイン処理
                Auth.login({
                  userId: tempUserId,
                  password: tempFirstPassword
                }).then(({ responce }) => {

                  this.$store.commit(
                    types.COMMON_AUTH_LOGIN,
                    {
                      userId: responce.data.userId,
                      token: responce.data.access_token
                    }
                  )

                  // ユーザー情報を取得
                  CommonConfirmReserveInfo.GetUserInfo({
                    token: this.$store.state.auth.token,
                    userId: tempUserId
                  }).then(({ userInfoResponce }) => {

                    if (userInfoResponce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

                      tempTrsq = userInfoResponce.data.trsq
                      tempName = userInfoResponce.data.name

                      // 既ログイン時 各パラメーターリセット、ユーザー情報一部再取得
                      this.$store.commit(
                        types.COMMON_CONFIRMRESERVE_REGISTERLOGININFO,
                        {
                          trsq: tempTrsq,
                          name: tempName,
                          ukno: tempUkno
                        })

                      // 予約確定画面に遷移
                      this.$router.push('/CommonReserveResult')

                     } else if (userInfoResponce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
                                || userInfoResponce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
                                || userInfoResponce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
                        this.onSystemErrorModalOpen()
                        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onConfirm End')
                     }

                  }).catch(() => {
                    this.onSystemErrorModalOpen()
                    UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onConfirm End')
                  })
                }).catch(() => {
                  this.onSystemErrorModalOpen()
                  UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onConfirm End')
                })
              }
              
            } else if (reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION) {
              this.onValidationErrorModalOpen(reserveResponce.data.errorMessagesList)
            } else if (reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
              || reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
              || reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
              this.onSystemErrorModalOpen()
            }

          }).catch(() => {
            this.onSystemErrorModalOpen()
          }).finally(() => {
            UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onConfirm End')
	        })

        } else if(this.userType == this.codeUserTypeMyPageNewIndividual
          || this.userType == this.codeUserTypeMyPageNewHealth
          || this.userType == this.codeUserTypeEnRouteNewIndividual
          || this.userType == this.codeUserTypeEnRouteNewHealth) {

          // ログイン済み新規予約
          // 0: マイページ経由かつ新規予約（個人）codeUserTypeMyPageNewIndividual
          // 1: マイページ経由かつ新規予約（健保）codeUserTypeMyPageNewHealth
          // 6: 途中ログインかつ新規予約（個人）codeUserTypeEnRouteNewIndividual
          // 7: 途中ログインかつ新規予約（健保）codeUserTypeEnRouteNewHealth
          CommonConfirmReserveInfo.LoginedNewReserve({
            token: this.$store.state.auth.token,
            userId: this.$store.state.auth.userId,
            ircd: this.$store.state.auth.ircd,
            jgcd: this.$store.state.commonUserInfo.newHealthInsurance.jgcd,
            jgnm: this.confirm.jgnm,
            hksh: this.confirm.hksh,
            newHealthInsuranceSex: this.$store.state.commonUserInfo.newHealthInsurance.sex,
            newHealthInsuranceBtdyYear: this.$store.state.commonUserInfo.newHealthInsurance.btdyYear,
            newHealthInsuranceBtdyMonth: this.$store.state.commonUserInfo.newHealthInsurance.btdyMonth,
            newHealthInsuranceBtdyDate: this.$store.state.commonUserInfo.newHealthInsurance.btdyDate,
            newHealthInsuranceNend: this.$store.state.commonUserInfo.newHealthInsurance.nend,
            newHealthInsuranceAge: this.$store.state.commonUserInfo.newHealthInsurance.age,
            newHealthInsuranceHfkb: this.$store.state.commonUserInfo.newHealthInsurance.hfkb,
            inputReserveSex: this.$store.state.commonUserInfo.inputReserveInfo.sex,
            inputReserveBtdyYear: this.$store.state.commonUserInfo.inputReserveInfo.btdyYear,
            inputReserveBtdyMonth: this.$store.state.commonUserInfo.inputReserveInfo.btdyMonth,
            inputReserveBtdyDate: this.$store.state.commonUserInfo.inputReserveInfo.btdyDate,
            inputReserveAge: this.$store.state.commonUserInfo.inputReserveInfo.age,
            inputReserveHfkb: this.$store.state.commonUserInfo.inputReserveInfo.hfkb,
            kscd: this.$store.state.commonUserInfo.selectCourse.kscd,
            courseJkcd: this.$store.state.commonUserInfo.selectCourse.jkcd,
            opbr: this.$store.state.commonUserInfo.selectOption.opbr,
            opcd: this.$store.state.commonUserInfo.selectOption.opcd,
            optionJkcd: this.$store.state.commonUserInfo.selectOption.jkcd,
            reserveDate: this.$store.state.commonUserInfo.selectCalender.date,
            reserveTmzn: this.$store.state.commonUserInfo.selectCalender.tmzn,
            jgnm: this.$store.state.commonUserInfo.inputReserveInfo.jgnm,
            hkkg: this.$store.state.commonUserInfo.inputReserveInfo.hkkg,
            hkno: this.$store.state.commonUserInfo.inputReserveInfo.hkno,
            cmnm: this.$store.state.commonUserInfo.inputReserveInfo.cmnm,
            nam1: this.$store.state.commonUserInfo.inputReserveInfo.nam1,
            nam2: this.$store.state.commonUserInfo.inputReserveInfo.nam2,
            ryk1: this.$store.state.commonUserInfo.inputReserveInfo.ryk1,
            ryk2: this.$store.state.commonUserInfo.inputReserveInfo.ryk2,
            zip1: this.$store.state.commonUserInfo.inputReserveInfo.zip1,
            zip2: this.$store.state.commonUserInfo.inputReserveInfo.zip2,
            adr1: this.$store.state.commonUserInfo.inputReserveInfo.adr1,
            adr2: this.$store.state.commonUserInfo.inputReserveInfo.adr2,
            adr3: this.$store.state.commonUserInfo.inputReserveInfo.adr3,
            tel1: this.$store.state.commonUserInfo.inputReserveInfo.tel1,
            syno: this.$store.state.commonUserInfo.inputReserveInfo.syno,
            email: this.$store.state.commonUserInfo.inputReserveInfo.email,
            dmkb: this.$store.state.commonUserInfo.inputReserveInfo.dmkb,
            mem1: this.$store.state.commonUserInfo.inputReserveInfo.mem1
          }).then(({ reserveResponce }) => {

            if (reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

              // 既ログイン時 各パラメーターリセット、ユーザー情報一部再取得
              this.$store.commit(
                types.COMMON_CONFIRMRESERVE_LOGINED,
                {
                  userId: reserveResponce.data.userId,
                  name: reserveResponce.data.name,
                  ukno: reserveResponce.data.ukno
                })

              // 予約確定画面に遷移
              this.$router.push('/CommonReserveResult')

            } else if (reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
                       || reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
                       || reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
              this.onSystemErrorModalOpen()
            }

          }).catch(() => {
            this.onSystemErrorModalOpen()
          }).finally(() => {
            UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onConfirm End')
	        })
        } else {
          // ログイン済み予約変更
          // 2: マイページ経由かつ予約変更（個人）codeUserTypeMyPageChangeIndividual
          // 3: マイページ経由かつ予約変更（健保）codeUserTypeMyPageChangeHealth
          CommonConfirmReserveInfo.LoginedChangeReserve({
            token: this.$store.state.auth.token,
            choiceUkno: this.$store.state.commonUserInfo.myPage.choiceUkno,
            userId: this.$store.state.auth.userId,
            ircd: this.$store.state.auth.ircd,
            jgcd: this.$store.state.commonUserInfo.newHealthInsurance.jgcd,
            jgnm: this.confirm.jgnm,
            hksh: this.confirm.hksh,
            newHealthInsuranceSex: this.$store.state.commonUserInfo.newHealthInsurance.sex,
            newHealthInsuranceBtdyYear: this.$store.state.commonUserInfo.newHealthInsurance.btdyYear,
            newHealthInsuranceBtdyMonth: this.$store.state.commonUserInfo.newHealthInsurance.btdyMonth,
            newHealthInsuranceBtdyDate: this.$store.state.commonUserInfo.newHealthInsurance.btdyDate,
            newHealthInsuranceNend: this.$store.state.commonUserInfo.newHealthInsurance.nend,
            newHealthInsuranceAge: this.$store.state.commonUserInfo.newHealthInsurance.age,
            newHealthInsuranceHfkb: this.$store.state.commonUserInfo.newHealthInsurance.hfkb,
            inputReserveSex: this.$store.state.commonUserInfo.inputReserveInfo.sex,
            inputReserveBtdyYear: this.$store.state.commonUserInfo.inputReserveInfo.btdyYear,
            inputReserveBtdyMonth: this.$store.state.commonUserInfo.inputReserveInfo.btdyMonth,
            inputReserveBtdyDate: this.$store.state.commonUserInfo.inputReserveInfo.btdyDate,
            inputReserveAge: this.$store.state.commonUserInfo.inputReserveInfo.age,
            inputReserveHfkb: this.$store.state.commonUserInfo.inputReserveInfo.hfkb,
            kscd: this.$store.state.commonUserInfo.selectCourse.kscd,
            courseJkcd: this.$store.state.commonUserInfo.selectCourse.jkcd,
            opbr: this.$store.state.commonUserInfo.selectOption.opbr,
            opcd: this.$store.state.commonUserInfo.selectOption.opcd,
            optionJkcd: this.$store.state.commonUserInfo.selectOption.jkcd,
            reserveDate: this.$store.state.commonUserInfo.selectCalender.date,
            reserveTmzn: this.$store.state.commonUserInfo.selectCalender.tmzn,
            jgnm: this.$store.state.commonUserInfo.inputReserveInfo.jgnm,
            hkkg: this.$store.state.commonUserInfo.inputReserveInfo.hkkg,
            hkno: this.$store.state.commonUserInfo.inputReserveInfo.hkno,
            cmnm: this.$store.state.commonUserInfo.inputReserveInfo.cmnm,
            nam1: this.$store.state.commonUserInfo.inputReserveInfo.nam1,
            nam2: this.$store.state.commonUserInfo.inputReserveInfo.nam2,
            ryk1: this.$store.state.commonUserInfo.inputReserveInfo.ryk1,
            ryk2: this.$store.state.commonUserInfo.inputReserveInfo.ryk2,
            zip1: this.$store.state.commonUserInfo.inputReserveInfo.zip1,
            zip2: this.$store.state.commonUserInfo.inputReserveInfo.zip2,
            adr1: this.$store.state.commonUserInfo.inputReserveInfo.adr1,
            adr2: this.$store.state.commonUserInfo.inputReserveInfo.adr2,
            adr3: this.$store.state.commonUserInfo.inputReserveInfo.adr3,
            tel1: this.$store.state.commonUserInfo.inputReserveInfo.tel1,
            syno: this.$store.state.commonUserInfo.inputReserveInfo.syno,
            email: this.$store.state.commonUserInfo.inputReserveInfo.email,
            dmkb: this.$store.state.commonUserInfo.inputReserveInfo.dmkb,
            mem1: this.$store.state.commonUserInfo.inputReserveInfo.mem1
          }).then(({ reserveResponce }) => {

            if (reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

              // 既ログイン時 各パラメーターリセット、ユーザー情報一部再取得
              this.$store.commit(
                types.COMMON_CONFIRMRESERVE_LOGINED,
                {
                  userId: reserveResponce.data.userId,
                  name: reserveResponce.data.name,
                  ukno: reserveResponce.data.ukno
                })
  
              // 予約確定画面に遷移
              this.$router.push('/CommonReserveResult')
            } else if (reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
                       || reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
                       || reserveResponce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
              this.onSystemErrorModalOpen()
            }

          }).catch(() => {
            this.onSystemErrorModalOpen()
          }).finally(() => {
            UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onConfirm End')
	        })
        }

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onConfirm End')
      },
      // 戻るボタン押下時
      onBack: function() {
        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onBack Start')

        // 予約入力画面に遷移
        this.$router.push("/CommonInputReserveInfo")

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onBack End')
      },
      // 予約処理中モーダルとしてモーダルを開く
      onReserveStartModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onReserveStartModalOpen Start')

        this.modalOpen('reserveStart')

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onReserveStartModalOpen End')
      },
      // 予約処理中モーダルを閉じる
      onReserveStartModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonConfirmCancel::onReserveStartModalClose Start')

        this.modalClose('reserveStart')

        UtilityConsoleLog.consoleLog('CommonConfirmCancel::onReserveStartModalClose End')
      },
      // 予約確認モーダルとしてモーダルを開く
      onReserveConfirmModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onReserveConfirmModalOpen Start')

        this.modalOpen('reserveConfirm')

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onReserveConfirmModalOpen End')
      },
      // 予約確認モーダルを閉じる
      onReserveConfirmModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonConfirmCancel::onReserveConfirmModalClose Start')

        this.modalClose('reserveConfirm')

        UtilityConsoleLog.consoleLog('CommonConfirmCancel::onReserveConfirmModalClose End')
      },
      // バリデーションエラーモーダルとしてエラーモーダルを開く
      onValidationErrorModalOpen: function (errorMessages) {

        UtilityConsoleLog.consoleLog('CommonConfirmCancel::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
        this.modalOpen('validationError')

        UtilityConsoleLog.consoleLog('CommonConfirmCancel::onValidationErrorModalOpen End')
      },
      // バリデーションエラーモーダルを閉じる
      onValidationErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onValidationErrorModalClose Start')

        this.modalClose('validationError')

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onValidationErrorModalClose End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルを閉じる
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onSystemErrorModalClose Start')

        this.modalClose('systemError')
        
				// URLパラム
				var tempParam = this.$store.getters.getCommonParam

				// トップ画面へ遷移
				this.$router.push('/CommonTop/' + tempParam)

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::onSystemErrorModalClose End')
      },
      // モーダルウィンドウを開く
      modalOpen: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('CommonConfirmReserveInfo::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/ConfirmReserveInfo/CommonConfirmReserveInfo.vue